import React, { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom'
import { createBrowserHistory } from 'history'

import './App.css'
import 'react-quill/dist/quill.snow.css'

import DefaultLayout from './DefaultLayout'
import PageNotFound from './container/PageNotFound/PageNotFound'
import Login from '../src/Admin/container/Login/Login'
import Dashboard from '../src/Admin/container/Dashboard/Dashboard'
import LoginD from '../src/container/Login/Login'
import WhatsAppButton from './component/WhatsAppButton/WhatsAppButton'
import TagManager from 'react-gtm-module';

const history = createBrowserHistory()

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuth = localStorage.getItem('isLoggedIn')
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth ? <Component {...props} /> : <Redirect to='/admin' />
      }
    />
  )
}

// 🔥 This component pushes path changes to GTM's dataLayer
const GTMRouteTracker = () => {
  const location = useLocation()

  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: `pageview ${location.pathname}`,
      page: location.pathname + location.search,
    })

    TagManager.dataLayer({
    dataLayer: {
    event: 'pageview',
    pagePath: location.pathname,  
  },
});
  }, [location])

  return null
}

const App = () => {
  return (
    <>
      <WhatsAppButton />
      <Router history={history}>
        <GTMRouteTracker />
        <Switch>
          <Route path='/login' component={LoginD} />
          <Route exact path='/admin' component={Login} />
          <PrivateRoute path='/admin/dashboard/' component={Dashboard} />
          <Route path='/' component={DefaultLayout} />
          <Route component={PageNotFound} />
        </Switch>
      </Router>
    </>
  )
}

export default App
